export default "__VITE_ASSET__ef7ba65b__"